import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Theme } from '@domgen/dgx-fe-common';
import {
  DescriptionListComponent,
  DescriptionListItemComponent,
} from '@domgen/dgx-fe-components/list';
import {
  PanelBorderRadius,
  PanelComponent,
} from '@domgen/dgx-fe-components/panel';
import {
  CurrencyFormatPipe,
  DateFormatPipe,
  provideTranslationDictionaryMapping,
  TranslatePipe,
} from '@domgen/dgx-fe-i18n';
import {
  LocallyStoredRegistrationData,
  PaymentFrequency,
  PlanDetails,
  PlanDetailsWib,
  RegistrationApplianceDetails,
} from '@us-registration/util-models';
import { translation } from '../../i18n/translation.constant';

@Component({
  selector: 'us-registration-confirmation-plan-details-panel',
  standalone: true,
  imports: [
    CurrencyFormatPipe,
    DateFormatPipe,
    DescriptionListComponent,
    DescriptionListItemComponent,
    NgIf,
    PanelComponent,
    TranslatePipe,
  ],
  templateUrl: './registration-confirmation-plan-details-panel.component.html',
  styleUrls: ['./registration-confirmation-plan-details-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class RegistrationConfirmationPlanDetailsPanelComponent {
  @Input() border = false;
  @Input() planDetails?: PlanDetails | PlanDetailsWib;
  @Input() registrationDetails?:
    | LocallyStoredRegistrationData
    | RegistrationApplianceDetails;
  @Input() applianceTermsAndConditions = '';
  @Input() planDetailsAnnualPrice?: number;
  @Input() rounded?: PanelBorderRadius = 'lg';
  @Input() stacked?: boolean;
  @Input() title?: string;
  @Input() variant: Theme = 'background';
  @Input() termsAndConditionsWib?: boolean;

  get isAnnualPlan(): boolean {
    return this.planDetails?.paymentFrequency === PaymentFrequency.Annual;
  }
}
